import { useEffect, useRef } from 'react';

const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a'
];

export const useKonami = (callback) => {
  const sequence = useRef([]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      sequence.current.push(e.key);

      // Keep only the last 10 keys
      if (sequence.current.length > KONAMI_CODE.length) {
        sequence.current.shift();
      }

      // Check if the sequence matches
      if (sequence.current.length === KONAMI_CODE.length) {
        const matches = sequence.current.every((key, index) => {
          return key === KONAMI_CODE[index];
        });

        if (matches) {
          sequence.current = [];
          callback();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);
};
